import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormTextField from "../../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../../components/formFields/CommonValidator";
import { setMiscellaneousDeleteIndex } from "../quotationSlice";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";

const QuotationMiscellaneousArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const MiscellaneousDeleteIndex = useAppSelector(
    (state) => state.quotation.MiscellaneousDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("miscellaneousDeleteDialog"));
    dispatch(setMiscellaneousDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setMiscellaneousDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Title: "",
        TotalAmount: null,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value || fieldArrayRenderProps?.value?.length < 1
        ? pushElementInarray()
        : null}
      {dialogName === "miscellaneousDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Miscellaneous"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(MiscellaneousDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((Miscellaneous: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "30%" },
                  { width: "30%" },
                  { width: "30%" },
                  { width: "10%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    name={`Miscellaneous.${index}.Title`}
                    label="Title"
                    placeholder="Title"
                    component={FormTextField}
                    validator={
                      fieldArrayRenderProps?.value[index]?.TotalAmount
                        ? requiredValidator
                        : skipValidator
                    }
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field"
                    name={`Miscellaneous.${index}.TotalAmount`}
                    label="Total Amount"
                    placeholder="0"
                    component={FormNumericTextField}
                    validator={
                      fieldArrayRenderProps?.value[index]?.Title
                        ? requiredValidator
                        : skipValidator
                    }
                  />
                </GridLayoutItem>
                <GridLayoutItem className="text-end" colSpan={2}>
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{
                      height: 30,
                      width: 30,
                      marginTop: 35,
                    }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "16px" }}
                  />
                </GridLayoutItem>
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}

      <GridLayoutItem style={{ textAlign: "end" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Miscellaneous
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default QuotationMiscellaneousArray;
